export default "__VITE_ASSET__B82yUQKL__"